
<p-panel>
    <div class="d-flex justify-content-left align-content-center">
        <div>
            <h4 *ngIf="flag === 'edit'">Actualizar {{this.env.clienteName}}</h4>
            <h4 *ngIf="flag === 'new'">Crear {{this.env.clienteName}}</h4>
        </div>
    </div>

    <div *ngIf="flag === 'edit' && this.env.appName === 'ebro'" class="alert alert-info p-2 small">
        <b><i class="fa fa-exclamation-circle"></i> Atención:</b>
        La sincronización con el sistema Sage sobreescribirá toda la
        información editada aquí, excepto el campo <code>observaciones</code>.
    </div>

   <div class="row">            
        <app-reactive-form-builder
                #formbuilder
                (formChanges)="formChanges($event[0], $event[1])"
                (goBack)="goBack()"
                (afterSend)="undefined"
                [form]="form.formFields"
                [serverUrl]="''"
                [dropdownLoadTrigger]="dropdownLoadTrigger"
                [previousData]="getModel()"
                [request]="this.getType() === 1 ? this.clientesApi.clientesPUT : this.clientesApi.clientesPOST">
        </app-reactive-form-builder>
    </div>
</p-panel>
<br>
